module.exports = __webpack_public_path__ + "media/images/countryrect/jm-fad73ce6f1deaedf56b321cc088de10b.svg";